module.exports = __webpack_public_path__ + "static/media/icono (1).c955e32c.svg";